import type { NoteStatus } from '@/lib/api/product-lot-api'
import { WarehouseNoteStatusBadge } from '@/components/warehouse/note-status-badge'
import { m } from '@/lib/paraglide/messages'

const LABEL: Record<NoteStatus, () => string> = {
    pending: () => m.product_lot_status_pending(),
    approved: () => m.product_lot_status_approved(),
    rejected: () => m.product_lot_status_rejected(),
    cancelled: () => m.product_lot_status_cancelled(),
}

interface Props {
    status: NoteStatus
    className?: string
}

export function ProductLotStatusBadge({ status, className }: Props) {
    const label = (LABEL[status] ?? LABEL.pending)()
    return (
        <WarehouseNoteStatusBadge
            status={status}
            label={label}
            className={className}
        />
    )
}
